import { render, staticRenderFns } from "./Emojis.vue?vue&type=template&id=79bd5f62&scoped=true"
import script from "./Emojis.vue?vue&type=script&lang=js"
export * from "./Emojis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bd5f62",
  null
  
)

export default component.exports